module.exports = __webpack_public_path__ + "static/media/image5.b4205006.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/image5.jpg
// module id = 368
// module chunks = 0